"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _Component = _interopRequireDefault(require("./Component"));

var _commands = require("../ducks/commands");

var mapStateToProps = function mapStateToProps(state) {
  return {
    inProcess: state['inProcess']
  };
};

var mapActionToProps = function mapActionToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeDialog: _commands.closeDialog
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapActionToProps)(_Component["default"]);

exports["default"] = _default;